export * from './company-config-type.enum';